import { registerHsAppsLoaderSingleton } from 'fe-lib-async-app';
import { getApp, registerApp } from 'fe-lib-async-app';
import { checkLogin } from './bundle'

registerHsAppsLoaderSingleton();
registerApp('hs-app-directory-admin', { checkLogin });
getApp('hs-app-directory-admin').then(({ checkLogin }) => checkLogin())
